import { makeStyles } from "@material-ui/styles";
import {
  CELL_HEIGHTS,
  CELL_WIDTHS,
  TIMELINE_MONTH_HEADER_HEIGHT,
} from "@utils";

export const TIMELINE_GRID_CELL_WIDTH = CELL_WIDTHS.VALUE.SMALL;

const useStyle = makeStyles((theme) => ({
  collapsed: {
    height: "100%",
  },
  expandButton: {
    position: "absolute",
    right: -4,
  },
  expandButtonExpanded: {
    right: 0,
  },
  label: {
    alignItems: "center",
    display: "flex",
    minHeight: CELL_HEIGHTS.XXXSMALL,
    minWidth: TIMELINE_GRID_CELL_WIDTH,
    justifyContent: "center",
    padding: "0 4px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    position: "relative",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "normal",
    textTransform: "uppercase",
  },
  body: {
    display: "flex",
    minWidth: TIMELINE_GRID_CELL_WIDTH,
    height: "100%",
  },
  month: {
    display: "flex",
    flexDirection: "column",
    minWidth: TIMELINE_GRID_CELL_WIDTH,
    backgroundColor: theme.props.backgroundSecondary,
    height: "100%",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    flex: "0 0 auto",
  },
  monthHeader: {
    display: "flex",
    flexDirection: "column",
    height: TIMELINE_MONTH_HEADER_HEIGHT,
    minHeight: TIMELINE_MONTH_HEADER_HEIGHT,
    position: "relative",
    zIndex: 5,
    backgroundColor: "inherit",
    "&:not(:hover) .monthHoverIcon": {
      zIndex: -1,
      opacity: 0,
    },
  },
  weekHeader: {
    display: "flex",
    flexDirection: "column",
    minWidth: TIMELINE_GRID_CELL_WIDTH,
    height: "100%",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    "&:not(:hover) .weekHoverIcon": {
      zIndex: -1,
      opacity: 0,
    },
  },
  monthBody: {
    borderRight: `1px solid ${theme.props.border}`,
  },
  activeMonthDivider: {
    borderRight: `1px solid ${theme.palette.primary.main} !important`,
  },
  firstMonthBody: {
    borderLeft: `1px solid ${theme.props.border}`,
  },
  weekBody: {
    "&:not(:last-child)": {
      borderRight: `1px dashed ${theme.props.border}`,
    },
    "&:last-child": {
      minWidth: TIMELINE_GRID_CELL_WIDTH - 1,
    },
  },
  activeWeekDivider: {
    "&:not(:last-child)": {
      borderRight: `1px dashed ${theme.palette.primary.main} !important`,
    },
  },
  dayBody: {
    "&:not(:last-child)": {
      borderRight: `1px dotted ${theme.props.border}`,
    },
    "&:last-child": {
      minWidth: TIMELINE_GRID_CELL_WIDTH - 1,
    },
  },
  isOver: {
    backgroundColor: theme.palette.primary.main + "20",
  },
  alternate: {
    backgroundColor: theme.props.primary.lightest,
  },
  activeMonth: {
    backgroundColor: theme.props.backgroundLevelAlt,
  },
  activeWeek: {
    backgroundColor: theme.props.backgroundLevel1,
  },
}));

export default useStyle;
